import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './lib/i18n'; // synchronous i18next init — must load before any t() use
import '@mdi/font/css/materialdesignicons.min.css'; // meter icons render by their mdi-* name
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
